export default __webpack_public_path__ + "static/icon-b0d33cda59c67cee216b2171935db6ea.ico";